import './App.css';
import React from 'react';
import Consulta from './componentes/Consultas/Consulta';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Navbar from './componentes/Navbar';
import MantenimientoArchivo from './componentes/MantenimientoArchivos/MantenimientoArchivo';
import Listado from './componentes/Listados/Listado';
import MovimientoReloj from './componentes/MovimientoReloj/MovimientoReloj';
import Parametros from './componentes/Parametros/Parametros';
import InformeServicioCivil from './componentes/ServicioCivil/InformeServicioCivil';
import Indexacion from './componentes/Indexacion/Indexacion';
import ControlSarampion from './componentes/ControlSarampion/ControlSarampion';
import DotacionFuncionarios from './componentes/DotacionFuncionarios/DotacionFuncionarios';
import Marcas from './componentes/Marcas/Marcas';
import Login from './componentes/Login/Login';
import IngresoFuncionarios from './componentes/MantenimientoArchivos/IngresoFuncionarios';
import IndexConsulta from './componentes/MantenimientoArchivos/Index';
import DatosMovimiento from './componentes/MantenimientoArchivos/DatosMovimiento';
import FichaCalificaciones from './componentes/MantenimientoArchivos/FichaCalificaciones';
import HorasDiasInhabiles from './componentes/MantenimientoArchivos/HorasDiasInhabiles';
import CambioHorario from './componentes/MantenimientoArchivos/CambioHorario';
import HorarioVariado from './componentes/MantenimientoArchivos/HorarioVariado';
import Horario from './componentes/MantenimientoArchivos/Horario';
import Licencias from './componentes/MantenimientoArchivos/Licencias';
import Inicio from './componentes/Inicio/Inicio';
import ConsultaMovimientos from './componentes/Consultas/ConsultaMovimientos';
import ControlAsistencia from './componentes/ControlAsistencia/ControlAsistencia'
import Informes from './componentes/Informes/Informes';
import InformesUsuario from './componentes/Informes/InformesUsuario';
import Registro from './componentes/Login/Registro';
import InformesJefes from './componentes/Informes/InformesJefes';
import ConsultaUsuario from './componentes/Consultas/ConsultaUsuario';
import ConsultaInformesUsuarios from './componentes/Consultas/ConsultaInformesUsuarios';
import ConsultasDatosPersonales from './componentes/Consultas/ConsultasDatosPersonales';
import ConsultasControlAsistenciaUsuario from './componentes/Consultas/ConsultasControlAsistenciaUsuario';
import ConsultasSaldosUsuario from './componentes/Consultas/ConsultasSaldosUsuario';
import Prueba from './componentes/Inicio/Prueba';
import Logo from './componentes/Inicio/Logo';
import GestionUsuarios from './componentes/Login/GestionUsuarios';
import CambioContrassenia from './componentes/Login/CambioContrassenia';
import { PriceChange } from '@mui/icons-material';
import PrimeraVez from './componentes/Login/PrimeraVez';
import Alertas from './componentes/Inicio/Alertas';
import ActividadesPendientes from './componentes/Actividades/ActividadesPendientes';
import Feriados from './componentes/MantenimientoArchivos/Feriados';
import Calificaciones from './componentes/MantenimientoArchivos/Calificaciones';
import Pruebas from './componentes/Pruebas/Pruebas';
import Subrogacion from './componentes/MantenimientoArchivos/Subrogacion';
import Barra from './componentes/Barra';
import { AppProvider, useAppContext } from './componentes/AppProvider';
import SaldoFuncionarios from './componentes/Consultas/SaldoFuncionarios';
import ConsultaFuncionario from './componentes/Consultas/ConsultaFuncionario';
import OmisionesFuncionario from './componentes/Consultas/OmisionesFuncionario';
import MarcasManual from './componentes/Consultas/MarcasManual';
import SalidaEntreHorario from './componentes/Consultas/SalidaEntreHorario';
import HorasSimpleExtras from './componentes/Consultas/HorasSimpleExtras';
import ControlAsistenciaConfirmada from './componentes/Consultas/ControlAsistenciaConfirmada';
import General from './componentes/Informes/General';
import ConsultasCalificaciones from './componentes/Consultas/ConsultasCalificaciones';
import HorarioCP from './componentes/MantenimientoArchivos/HorarioCP';
import CambioPassword from './componentes/Login/CambioPassword';
import MarcasMensual from './componentes/MantenimientoArchivos/MarcasMensual';
import MarcasRelojMensual from './componentes/Consultas/MarcasRelojMensual';
import Reportes from './componentes/Reportes/Reportes';
import ConsultaMarcasPlanilla from './componentes/Consultas/ConsultaMarcasPlanilla';
import Ini from './componentes/Inicio/Ini';
import PlanillaDescuento from './componentes/MantenimientoArchivos/PlanillaDescuento';
import CambiosFuncionario from './componentes/MantenimientoArchivos/CambiosFuncionario';
import ConsultaInformes from './componentes/Consultas/ConsultaInformes';
import FuncionariosJefes from './componentes/MantenimientoArchivos/FuncionariosJefes';
import Circulares from './componentes/Inicio/Circulares';
import ConsultasFinal from './componentes/Consultas/ConsultasFinal';
import GenerarPDF from './componentes/InformesPDF/GenerarPDF';
import ConsultaInformesCalificaciones from './componentes/Consultas/ConsultaInformesCalificaciones';
import AlertasPersonal from './componentes/Inicio/AlertasPersonal';
import ConsultaJefes from './componentes/Consultas/ConsultaJefes';
import ConsultaCalificaciones from './componentes/Consultas/ConsultaCalificaciones';
import ConsultaSolicitudesFuncionarios from './componentes/Consultas/ConsultaSolicitudesFuncionarios';
import Notificarse from './componentes/MantenimientoArchivos/Notificarse';
import AlertasFuncionario from './componentes/Inicio/AlertasFuncionario';
import ConsultasSV from './componentes/Consultas/ConsultasSV';
import Ranking from './componentes/Consultas/Ranking';
import ConsultasInformesSV from './componentes/Consultas/ConsultasInformesSV';
import PlanillaSV from './componentes/Consultas/PlanillaSV';
import PagosRealizados from './componentes/Consultas/PagosRealizados';
import GestionUsuario from './componentes/MantenimientoArchivos/GestionUsuario';
import RestablecerContrasenia from './componentes/Login/RestablecerContrasenia';
import UsuarioAsociado from './componentes/Login/UsuarioAsociado';
import Sorteos from './componentes/MantenimientoArchivos/Sorteos';
import Ingreso from './componentes/Leo/Ingreso';
import PlanoStock from './componentes/Leo/PlanoStock';
import Resoluciones from './componentes/MantenimientoArchivos/Resoluciones';
import Asiduidad from './componentes/MantenimientoArchivos/Asiduidad';
import Concursos from './componentes/Concursos/Concursos';
import InscripcionConcurso from './componentes/Concursos/InscripcionConcurso';
import AgregarConcurso from './componentes/Concursos/AgregarConcurso';
import EnviarMails from './componentes/Concursos/EnviarMails';
import AgregarSuspendida from './componentes/MantenimientoArchivos/AgregarSuspendida';
import UsuariosEspeciales from './componentes/Login/UsuariosEspeciales';
import NIvelEducativo from './componentes/Consultas/NIvelEducativo';
import NivelEducativoPersonal from './componentes/Consultas/NivelEducativoPersonal';
import DescuentosDiariosMensuales from './componentes/Consultas/DescuentosDiariosMensuales';
import Jornaleros from './componentes/Consultas/Jornaleros';
import Medicos from './componentes/Consultas/Medicos';
import ControlAsistenciaNuevo from './componentes/ControlAsistencia/ControlAsistenciaNuevo';
import ConsultarInscriptos from './componentes/Concursos/ConsultarInscriptos';
import MontoRetroactivo from './componentes/Consultas/MontoRetroactivo';
import ConsultaRetroactivo from './componentes/Consultas/ConsultaRetroactivo';
import BolsaTrabajoChoferes from './componentes/Concursos/BolsaTrabajoChoferes';
import ConsultarInscriptosBolsa from './componentes/Concursos/ConsultarInscriptosBolsa';
import ConsultaMovimientosFuncionarios from './componentes/Consultas/ConsultaMovimientosFuncionarios';
import DatosFuncionarios from './componentes/Consultas/DatosFuncionarios';
import Organigrama from './componentes/MantenimientoArchivos/Organigrama';
import ConsultaCalificacionesUsuarios from './componentes/MantenimientoArchivos/ConsultaCalificacionesUsuarios';

function App() {
    return (
        <>
            <Router>
                {/*<Navbar/>*/}
                {/*<AppProvider>*/}
                {/*<Barra sinLogin={sessionStorage.sinLogin}/>*/}
                {/*</AppProvider>*/}
                {/*<Logo/>*/}
                
                <div className="App">
                    <Switch>

                        {/*------------------- */}
                        {/*Rutas validas*/}

                        {/*-----------------------------------------------------------------------------*/}
                        {/*Login*/}
                        <Route path={'*/inicio'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Inicio/>
                            <br/>
                            {/*<Prueba/>*/}
                        </Route>

                        <Route path={'*/ini'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Ini/>
                            <br/>
                            {/*<Prueba/>*/}
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}
                        {/*Login*/}
                        <Route path={'*/login'}>
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Login/>
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}
                        {/*Login*/}
                        <Route path={'*/registro'}>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Registro/>
                        </Route>

                        <Route path={'*/gestion-usuarios'}>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <GestionUsuarios/>
                        </Route>

                        <Route path={'*/cambio'}>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <CambioContrassenia/>
                        </Route>

                        <Route path={'*/primera-vez'}>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <PrimeraVez/>
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}
                        <Route path={'*/Actividades-pendientes'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <ActividadesPendientes/>
                        </Route>
                        {/*-----------------------------------------------------------------------------*/}
                        <Route path={'*/Pruebas'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Pruebas/>
                        </Route>
                        {/*-----------------------------------------------------------------------------*/}
                        <Route path={'*/Calificaciones'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Calificaciones/>
                        </Route>
                        {/*-----------------------------------------------------------------------------*/}
                        {/*Mantenimiento de Archivos*/}
                        <Route path={"*/MantArchivo"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <MantenimientoArchivo/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-Resoluciones"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <Resoluciones/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-AgregarLicenciaSuspendida"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <AgregarSuspendida/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Notificarse"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <Notificarse/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        {/*<Route path={"/MantArchivo-Index"} exact>
                            <IndexConsulta/>
                        </Route>*/}
                        <Route path={'*/MantArchivo-Ingreso'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <IngresoFuncionarios/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-DatosMovimiento"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <DatosMovimiento/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/leoPrueba"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '1'
                            ?
                                <PlanoStock/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consultas-SolicitudesFuncionarios"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '3'
                            ?
                                <ConsultaSolicitudesFuncionarios/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"/MantArchivo/AntAdmPublica"} exact>
                            
                        </Route>
                        <Route path={"*/MantArchivo-FichaCalificaciones"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <FichaCalificaciones/>
                        </Route>
                        <Route path={"*/MantArchivo-FuncionariosJefes"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <FuncionariosJefes/>
                        </Route>
                        <Route path={"*/MantArchivo-HorasDiasInhabiles"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <HorasDiasInhabiles/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-CambioHorario"} exact>
                            {/*<CambioHorario/>*/}
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario
                            ?
                                <Horario/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-HorarioVariado"} exact>
                            {/*<HorarioVariado/>*/}
                            
                        </Route>
                        <Route path={"*/MantArchivo-Subrogacion"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <Subrogacion/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/GestionUsuarios-cambioPassword"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <CambioPassword/>
                        </Route>
                        <Route path={"*/MantArchivo-HorarioCP"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <HorarioCP/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-cargaMarcasMensual"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <MarcasMensual/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-planillaDescuento"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <PlanillaDescuento/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-cambioFuncionario"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <CambiosFuncionario/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-Asiduidad"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <Asiduidad/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consultar-Organigrama"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <Organigrama/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-LicenciaEspecial"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario
                            ?
                                <Licencias/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-Feriados"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario
                            ?
                                <Feriados/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"/MantArchivo/LicReglamentaria"} exact>
                            
                        </Route>
                        <Route path={"/MantArchivo/ActualizarAntiguedad"} exact>
                            
                        </Route>
                        <Route path={"/MantArchivo/AgregaLicencia"} exact>
                            
                        </Route>
                        <Route path={"/MantArchivo/AgregaAsueto"} exact>
                            
                        </Route>
                        <Route path={"/MantArchivo/AgregaLicenciaFamiliarInternado"} exact>
                            
                        </Route>
                        <Route path={"/MantArchivo/AgregaLicenciaEnfermo"} exact>
                            
                        </Route>
                        <Route path={"/MantArchivo/AgregaLicenciaLey"} exact>
                            
                        </Route>
                        <Route path={"/MantArchivo/AgregaLicenciaEstudio"} exact>
                            
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}
                        <Route path={'*/Consultas-InformesSV'} exact>
                            {sessionStorage.tipoUsuario === '6'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultasInformesSV/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-PlanillasSV'} exact>
                            {sessionStorage.tipoUsuario === '6'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <PlanillaSV/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-NivelEducativo'} exact>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <NIvelEducativo/>
                                </>
                            :
                                sessionStorage.tipoUsuario === '4'
                                ?
                                    <>
                                        {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                        <Barra sinLogin={sessionStorage.sinLogin}/>
                                        <Logo/>
                                        <NivelEducativoPersonal/>
                                    </>
                                :
                                    <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consultas"} exact>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultaUsuario/>
                                </>
                            :
                                sessionStorage.tipoUsuario === '4'
                                ?
                                    <>
                                        {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                        <Barra sinLogin={sessionStorage.sinLogin}/>
                                        <Logo/>
                                        <Consulta />
                                    </>
                                :
                                    sessionStorage.tipoUsuario === '5'
                                    ?
                                        <>
                                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                            <Barra sinLogin={sessionStorage.sinLogin}/>
                                            <Logo/>
                                            <ConsultasFinal/>
                                        </>
                                    :
                                        sessionStorage.tipoUsuario === '3'
                                        ?
                                            <>
                                                {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                                <Barra sinLogin={sessionStorage.sinLogin}/>
                                                <Logo/>
                                                <ConsultaJefes/>
                                            </>
                                        :
                                            sessionStorage.tipoUsuario === '6'
                                            ?
                                                <>
                                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                                    <Logo/>
                                                    <ConsultasSV/>
                                                </>
                                            :
                                                <>
                                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                                    <Logo/>
                                                    <Inicio />
                                                </>
                            }
                        </Route>
                        <Route path={"*/Consultas-usuario"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <ConsultaUsuario/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-Calificaciones"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <ConsultaCalificacionesUsuarios/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consultas-MovimientosFuncionarios"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {(sessionStorage.tipoUsuario === '3') && (sessionStorage.lugarCentral === '20')
                            ?
                                <ConsultaMovimientosFuncionarios/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consulta-DatosFuncionarios"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {(sessionStorage.tipoUsuario === '3') && (sessionStorage.lugarCentral === '20')
                            ?
                                <DatosFuncionarios/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/MantArchivo-Retroactivo"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <ConsultaRetroactivo/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consultas-MontoRetroactivo"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <MontoRetroactivo/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consultas-DescuentosDiariosManuales"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <DescuentosDiariosMensuales/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consulta-Calificaciones"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '3'
                            ?
                                <ConsultaCalificaciones/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={"*/Consultas-Solicitudes"} exact>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultaInformesUsuarios/>
                                </>
                            :
                                null
                            }
                        </Route>
                        <Route path={"*/Circulares"} exact>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <Circulares/>
                                </>
                            :
                                null
                            }
                        </Route>
                        <Route path={"*/Consultas-Calificaciones"} exact>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultasCalificaciones/>
                                </>
                            :
                                null
                            }
                        </Route>
                        <Route path={"*/Consultas-Jornaleros"} exact>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <Jornaleros/>
                                </>
                            :
                                null
                            }
                        </Route>
                        <Route path={"*/Consultas-Medicos"} exact>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <Medicos/>
                                </>
                            :
                                null
                            }
                        </Route>
                        <Route path={'*/Consultas-DatosPersonales'} exact>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultasDatosPersonales/>
                                </>
                            :
                                null
                            }
                        </Route>
                        <Route path={'*/Consultas-ControlAsistencia'} exact>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultasControlAsistenciaUsuario/>
                                </>
                            :
                                sessionStorage.tipoUsuario === '4'
                                ?
                                    <>
                                        {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                        <Barra sinLogin={sessionStorage.sinLogin}/>
                                        <Logo/>
                                        <ControlAsistencia/>
                                    </>
                                :
                                    null
                            }
                        </Route>
                        <Route path={'*/Consultas-Saldos'} exact>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultasSaldosUsuario/>
                                </>
                            :
                                null
                            }
                        </Route>
                        <Route path={'*/Consultas-Movimientos'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <ConsultaMovimientos/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-MarcasRelojesMensual'} exact>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <MarcasRelojMensual/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-SaldoFuncionario'}>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null}
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <SaldoFuncionarios/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Sorteos'}>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null}
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <Sorteos/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-PagosRealizados'}>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null}
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '6'
                            ?
                                <PagosRealizados/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-OmisionesFuncionario'}>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null}
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <OmisionesFuncionario/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-MarcasManual'}>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null}
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <MarcasManual/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-SalidasEntreHorario'}>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null}
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <SalidaEntreHorario/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-Funcionario'}>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null}
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <ConsultaFuncionario/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/ControlAsistencia'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <ControlAsistenciaNuevo/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-HoraSimplesExtras'} exact>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <HorasSimpleExtras/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-ControlAsistenciaConfirmadas'} exact>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <ControlAsistenciaConfirmada/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-MarcasRelojesMensualPlanilla'} exact>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <ConsultaMarcasPlanilla/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Reportes'} exact>
                            {sessionStorage.tipoUsuario === '4' ? <Alertas/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <Reportes/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'/Consultas/ResumenMovCodigo'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/HorasPendientes'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/LicenciaReglamentaria'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/MarcadaFuncionamieno'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/RepeticionEnfermedades'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/ListadoPrima'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/ListadoLicenciaPendiente'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/ListadoAntiguedad'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/ListadoAsuetos'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/ListadoEnfermedades'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/LicenciaAnual'} exact>
                            
                        </Route>
                        <Route path={'/Consultas/BorrarRepetidos'} exact>
                            
                        </Route>

                        <Route path={'*/GestionUsuario'} exact>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <GestionUsuario/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/GestionUsuarios-restablecerContrasenia'} exact>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <RestablecerContrasenia/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/GestionUsuarios-usuariosEspeciales'} exact>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <UsuariosEspeciales/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/GestionUsuarios-usuarioAsiciado'} exact>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <UsuarioAsociado/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        {/*-------------------------------------------Concursos--------------------------------------------------*/}
                        <Route path={'*/Concursos'} exact>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null}
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <Concursos/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/InscripcionConcurso-Consultar'} exact>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null}
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultarInscriptos/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/InscripcionBolsa-Consultar'} exact>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null}
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ConsultarInscriptosBolsa/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/personal-app/ControlAsistenciaNuevo'} exact>
                            {sessionStorage.tipoUsuario === '4' && sessionStorage.numeroFuncionarioAsociado === '11112'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <ControlAsistenciaNuevo/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/EnviarMailsConcurso'} exact>
                            {sessionStorage.tipoUsuario === '4' && sessionStorage.numeroFuncionarioAsociado === '11112'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <EnviarMails/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/InscripcionConcurso'} exact>
                            {/*sessionStorage.tipoUsuario === '4' && sessionStorage.numeroFuncionarioAsociado === '11112'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <InscripcionConcurso/>
                                </>
                            :
                                <Inicio/>
                            */}
                            <>
                                <Barra sinLogin={sessionStorage.sinLogin}/>
                                <Logo/>
                                <InscripcionConcurso/>
                            </>
                        </Route>
                        <Route path={'*/BolsaTrabajoChoferes'} exact>
                            <>
                                <Barra sinLogin={sessionStorage.sinLogin}/>
                                <Logo/>
                                <BolsaTrabajoChoferes/>
                            </>
                        </Route>
                        <Route path={'*/AgregarConcurso'} exact>
                            {sessionStorage.tipoUsuario === '4' && sessionStorage.numeroFuncionarioAsociado === '11112'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <AgregarConcurso/>
                                </>
                            :
                                <Inicio/>
                            }
                        </Route>
                        {/*-------------------------------------------Concursos--------------------------------------------------*/}
                        {/*-----------------------------------------------------------------------------*/}
                        <Route path={'*/Informes'} exact>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <>
                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                    <Logo/>
                                    <General/>
                                </>
                            :
                                sessionStorage.tipoUsuario === '3'
                                ?
                                    <>
                                        {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                        <Barra sinLogin={sessionStorage.sinLogin}/>
                                        <Logo/>
                                        <InformesJefes/>
                                    </>
                                :
                                    sessionStorage.tipoUsuario === '4'
                                    ?
                                        <>
                                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                            <Barra sinLogin={sessionStorage.sinLogin}/>
                                            <Logo/>
                                            <Informes/>
                                        </>
                                    :
                                        sessionStorage.tipoUsuario === '5'
                                        ?
                                            <>
                                                {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                                <Barra sinLogin={sessionStorage.sinLogin}/>
                                                <Logo/>
                                                <Informes/>
                                            </>
                                        :
                                            sessionStorage.tipoUsuario === '6'
                                            ?
                                                <>
                                                    {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                                                    <Barra sinLogin={sessionStorage.sinLogin}/>
                                                    <Logo/>
                                                    <Informes/>
                                                </>
                                            :
                                                null
                            }
                        </Route>
                        <Route path={'*/Informes-SV'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Informes/>
                        </Route>
                        <Route path={'*/Informes-GenerarPDF'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '5'
                            ?
                                <GenerarPDF/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-Ranking'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '4'
                            ?
                                <Ranking/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'*/Consultas-Informes'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <ConsultaInformes/>
                        </Route>
                        <Route path={'*/Consultas-InformesCalificaciones'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <ConsultaInformesCalificaciones/>
                        </Route>
                        <Route path={'*/Informes-jefes'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <InformesJefes/>
                        </Route>
                        <Route path={'*/Informes-P'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Informes/>
                        </Route>
                        <Route path={'*/Informes-JF'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Informes/>
                        </Route>
                        <Route path={"*/Informes-usuario"} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            {sessionStorage.tipoUsuario === '2'
                            ?
                                <General/>
                            :
                                <Inicio/>
                            }
                        </Route>
                        <Route path={'/Listados/MaestroPersonal'} exact>

                        </Route>
                        <Route path={'/Listados/ControlMensual'} exact>

                        </Route>
                        <Route path={'/Listados/ListadoFechasFaltas'} exact>

                        </Route>
                        <Route path={'/Listados/MovimientosFecha'} exact>

                        </Route>
                        <Route path={'/Listados/MovimientoNumeroCodigo'} exact>

                        </Route>
                        <Route path={'/Listados/FaltasMes'} exact>

                        </Route>
                        <Route path={'/Listados/AdministracionPublica'} exact>

                        </Route>
                        <Route path={'/Listados/PrimaCompensacion'} exact>

                        </Route>
                        <Route path={'/Listados/InformePrimaAsiduidad'} exact>

                        </Route>
                        <Route path={'/Listados/AntiguedadPromociones'} exact>

                        </Route>
                        <Route path={'/Listados/MovimientosLugarFecha'} exact>

                        </Route>
                        <Route path={'/Listados/ListadoServicioCivil'} exact>

                        </Route>
                        <Route path={'/Listados/Informes'} exact>

                        </Route>
                        <Route path={'/Listados/Solicitudes'} exact>

                        </Route>
                        <Route path={'/Listados/RegimenLicenciaHoraria'} exact>

                        </Route>
                        <Route path={'/Listados/Calificaciones'} exact>

                        </Route>
                        <Route path={'/Listados/FaltaSuspension'} exact>

                        </Route>
                        <Route path={'/Listados/EscalafonInterior'} exact>

                        </Route>
                        <Route path={'/Listados/30Anios'} exact>

                        </Route>
                        <Route path={'/Listados/ProfesionalesUniversitarios'} exact>

                        </Route>
                        <Route path={'/Listados/Suspensiones'} exact>

                        </Route>
                        <Route path={'/Listados/ExtraordinariaSueldo'} exact>

                        </Route>

                        {/*-----------------------------------------------------------------------------*/}

                        <Route path={'/IncMoviReloj'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <MovimientoReloj/>
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}

                        <Route path={'/Parametros'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Parametros/>
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}

                        <Route path={'/InfCursos'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <InformeServicioCivil/>
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}

                        <Route path={'/Indexacion'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Indexacion/>
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}

                        <Route path={'/ContAsisCamSara'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <ControlSarampion/>
                        </Route>
                        <Route path={'/ContAsisCamSara/MantenimientoDatos'} exact>

                        </Route>
                        <Route path={'/ContAsisCamSara/IngresoUnidades'} exact>

                        </Route>
                        <Route path={'/ContAsisCamSara/Listados'} exact>

                        </Route>

                        {/*-----------------------------------------------------------------------------*/}

                        <Route path={'/DotacFuncionarios'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <DotacionFuncionarios/>
                        </Route>

                        {/*-----------------------------------------------------------------------------*/}

                        <Route path={'/IngresoMarcas'} exact>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Marcas/>
                        </Route>
                        <Route path={'/IngresoMarcas/Ingreso'} exact>

                        </Route>
                        <Route path={'/IngresoMarcas/BajaModificaciones'} exact>

                        </Route>
                        

                        {/*-----------------------------------------------------------------------------*/}
                        <Route path={'*'}>
                            {sessionStorage.tipoUsuario === '2' ? <AlertasFuncionario/> : sessionStorage.tipoUsuario === '3' ? <Alertas/> : sessionStorage.tipoUsuario === '4' ? <AlertasPersonal/> : null }
                            <Barra sinLogin={sessionStorage.sinLogin}/>
                            <Logo/>
                            <Inicio/>
                        </Route>
                    </Switch>
                </div>
            </Router>
        </>
    );
}

export default App;
